// @flow

import { map } from 'ramda'

import { generateIdFromTitle } from '../../../helpers'
import type { OverviewItem } from '../../../types'

const overview = [
  {
    title: 'One Gorgeous Cottage',
    message: 'The gorgeous Coconut Cottage has comfort to spare.',
  },
  {
    title: 'Beautiful Views, Steps from the Gulf',
    message:
      'Enjoy the beautiful views while luxuriating in this designer decorated cottage.',
  },
  {
    title: 'Room Configuration',
    message: '2 Bedroom (1 Q, 2 T) 2 Bath with a sleeper sofa in living room.',
  },
]

export const coconutOverview: OverviewItem[] = map(
  generateIdFromTitle,
  overview,
)

export default coconutOverview
